<template lang="pug">
div
  el-divider 显示字段
  field-setting(v-bind="$props", v-model="displayFieldName", label="关联显示字段")
  el-form-item(label="显示格式")
    el-select(v-model="dictDisplayMode")
      el-option(v-for="{ id, cnName } in formatList", :key="id", :label="cnName", :value="id")
  el-divider 关联字典
  el-form-item(label-width="0")
    dict-select(v-model="dictType", size="mini", @change="changeDict")
  el-form-item(label="默认值")
    el-select.select.width-full(v-model="defaultDict", size="mini", clearable, filterable, :multiple="multiple_")
      el-option(v-for="{ dicId, cnName } in dicts", :key="dicId", :label="cnName", :value="dicId")
  el-form-item(label="组件风格")
    el-select.select.width-full(v-model="controlStyle", size="mini")
      el-option(v-for="{ label, value } in controlStyles", :key="value", :label="label", :value="value")
</template>
<script>
import { mapVFOptions, settingMixin } from "@/CommonDP/VForm/utils";
import { getDictListByCode, VF_DICT_ENUM } from "./index.js";
import DictSelect from "./dict-select.vue";
export default {
  components: { DictSelect },
  mixins: [settingMixin],
  data() {
    return {
      dicts: [],
      controlStyles: [
        { label: "下拉选择", value: "select" },
        { label: "多选组/单选组", value: "checkbox" }
      ],
      defaultValue: "",
      formatList: [
        { id: VF_DICT_ENUM.label, cnName: "标题" },
        { id: VF_DICT_ENUM.key_Label, cnName: "值-标题" }
      ]
    };
  },
  inject: ["serverFieldList", "getDesignerConfig", "subformFieldList", "isSubFormChildWidget"],
  computed: {
    ...mapVFOptions(["dictType", "dictDisplayMode", "displayFieldName", "defaultDict", "multiple_", "controlStyle"]),
    fieldList() {
      return this.isSubFormChildWidget() ? this.subformFieldList() : this.serverFieldList;
    },
    widgetNameReadonly() {
      return !!this.getDesignerConfig().widgetNameReadonly;
    }
  },
  watch: {
    dictType: {
      immediate: true,
      handler(dict) {
        this.getDict(dict);
      }
    }
  },
  methods: {
    changeDict(dicCode) {
      this.defaultDict = this.multiple_ ? [] : "";
      this.getDict(dicCode);
    },
    async getDict(dicCode) {
      this.dicts = [];
      this.dicts = await getDictListByCode(dicCode);
    }
  }
};
</script>
<style lang="scss" scoped src="./index.scss"></style>
